// Models
import { ClientClient, ClientModel } from "@/core/api/apiClient";

const SystemService = {
  /**
   * Gets all Clients.
   *
   * @returns {Promise<ClientModel[] | any>} Promise-wrapped data.
   * @author Nick Brahimir
   */
  async getAllClients(): Promise<ClientModel[] | any> {
    const clientClient = new ClientClient();

    return await clientClient
      .listClients()
      .then((data) => {
        return data.model;
      })
      .catch((error) => {
        console.error(error);
      });
  }
};

export default SystemService;
